import React from 'react';
import Grid from '../layout/grid';

export default props => {
	return (
		<input {...props.input}
			className='form-control'
			maskChar={' '}
			style={{ fontSize: props.fontSize, minWidth: props.minWidth || 165, maxWidth: props.maxWidth || 165 }}
			placeholder={props.placeholder}
			readOnly={props.readOnly} type={'date'}
			value={(props.value || '').split('/').join('-').split('T')[0]}
			onChange={data => props.onChange(data.target.value || null)} />
	);
}
